export enum NavigationPages {
  Notes = 'notes',
  Settings = 'settings',
  Login = 'login',
  Support = 'support',
  AdminNotes = 'adminNotes',
  connectedNotes = 'connectedNotes',
}

export enum NotePageSections {
  CareCues = 'careCues',
  Transcript = 'transcript',
}

export enum SettingsPageSections {
  Preferences = 'preferences',
  Templates = 'templates',
}

export type NavigationSections = NotePageSections | SettingsPageSections;
